import { axiosClient, buildQuery } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalPage } from '@nx-frontend/shared/types';

export interface GetPortalPagesParams {
  workspaceId: string;
  noteId?: string;
}

export async function getPortalPages(params: GetPortalPagesParams): Promise<PortalPage[]> {
  if (!params.workspaceId) {
    throw new Error('Assertion: no workspaceId provided for getPortalPages');
  }
  const queryParams = buildQuery(params);
  const query = queryParams ? `?${queryParams}` : '';
  const { data } = await axiosClient.get(`${generalEnv.nextCommonApiUrl}/portal/pages${query}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return data;
}
